<template lang="pug">
  .full-width.nav-background
    v-toolbar(light flat color="white")
      v-layout.px-3(row wrap)
        v-flex.wf-vertical-horizontal-center(xs1)
          div(v-if="!noBackChevron && !easyLinkUser")
            router-link.wf-vertical-horizontal-center(
              v-if="path"
              :to="path"
              tag="div"
            )
              v-icon.mr-3.wf-pointer(
                color="primary"
              ) chevron_left
            a.wf-vertical-horizontal-center(
              v-else href="#" tag="div"
              @click.prevent="$router.go(-1)"
            )
              v-icon(
                color="primary"
              ) chevron_left

        v-flex.wf-vertical-horizontal-center.text-xs-center(xs10)
          v-toolbar-title(
            v-if="$route.meta.navName === 'Home'"
          )
          v-toolbar-title(
            v-else
            class="toolbar-title"
          ) {{ navName[0] }}
            span  {{ navName[1] }}

        v-flex.wf-vertical-horizontal-center(xs1)
          v-icon.wf-pointer(
            v-if="!easyLinkUser && !noMenuIcon"
            color="primary"
            @click.stop="swapDrawer"
          ) menu

    HomeNavDrawer(
      v-bind="{ drawer }"
      @swapDrawer="swapDrawer"
    )
    span
</template>

<script>
  import HomeNavDrawer from 'Components/HomeNavDrawer.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'navbar',
    components: {
      HomeNavDrawer,
    },
    data () {
      return {
        bannerItems: [],
        drawer: null,
        navNameParts: []
      }
    },
    props: {
      backButtonPath: {
        type: String,
        default: ''
      },
      flexType: {
        type: String,
        default: 'responsive-flex',
      },
      noBackChevron: {
        type: Boolean,
        default: false
      },
      noMenuIcon: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState({
        easyLinkUser: state => state.easyLink.active,
        preQualApplication: state => state.preQualification.hasPreQual,
        lender: state => state.loanApplication.lender.id,
        isWellsFargoApplicant: state => state.user.isWellsFargoApplicant
      }),
      path () { return this.backButtonPath },
      navName(){
        let result
        if(this.$route.meta.navName === 'Credit Application' && this.lender === 'greensky'){
          this.preQualApplication ? result = 'Prequalification' : result = 'Credit Application'
        } else if (this.$route.meta.navName === 'Credit Application' && this.lender === 'wellsfargo') { 
          result = ''
        } else if (this.$route.meta.navName === 'Unexpected Error' && this.lender === 'wellsfargo' && !this.isWellsFargoApplicant)
          result = 'Error Info'
        else {
          result = this.$route.meta.navName
        }

        // This splits the navName into the first part and the second part
        // The first part consists of all words except the last and the end part consists of the last word
        // It is stored in a 2-wide array of two strings
        if (result) {
          const split = result.split(' ')
          if (split.length !== 1) {
            const first = split.slice(0, split.length - 1).join(' ')
            const end = split[split.length - 1]
            return [first, end]
          }
          else {
            return split
          }
        }
        else
          return ''
      },
    },
    methods: {
      emitSwap() {
        this.$emit('swapDrawer')
      },
      swapDrawer () {
        this.drawer = !this.drawer
      },
    },
  }
</script>

<style scoped lang="scss">
@import '../style_partials/global_vars';
@font-face {
    font-family: bebasNeue;
    src: url(../assets/fonts/bebas-neue.ttf);
    font-weight: bold;
    font-style: normal;
    size-adjust: 125%;
}
.toolbar-title {
  font-family: bebasNeue;
  color: $primaryColor;
}
.toolbar-title > span {
  color: $secondaryColor;
}
</style>